import { observer } from 'mobx-react-lite';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Header, Segment } from 'semantic-ui-react';
import { useStore } from '../../app/stores/store';

export default observer(function ServerError() {
    const { t } = useTranslation();
    const {commonStore} = useStore();
    
    return (
        <Container>
            <Header as='h1' content={t('serverError.title')} />
            <Header sub as='h5' color='red' content={commonStore.error?.message} />
            {commonStore.error?.details && 
                <Segment>
                    <Header as='h4' content={t('serverError.stackTrace')} color='teal' />
                    <code style={{marginTop: '10px'}}>{commonStore.error.details}</code>
                </Segment>
            }
        </Container>
    )
})